// extracted by mini-css-extract-plugin
export default {"tabletBreak":"769px","desktopBreak":"1024px","widescreenBreak":"1216px","fullHdBreak":"1408px"};